module.exports = __webpack_public_path__ + "media/images/sp/stores/asakusa/asakusa_sns_06-000a39c9efa133ccd2c223cd88a1cf66.jpg";